<template>
  <div class="key-text-ctn">
    <pre class="key-text">{{text}}</pre>
  </div>
</template>

<script>
export default {
  name: "key",
  props: {
    text: String
  },
}
</script>

<style scoped>
.key-text-ctn {
  overflow: auto;
  max-height: 400px;
}
.key-text {
  text-align: left;
  font-family: "DejaVu Sans Mono" !important;
}
</style>